// extracted by mini-css-extract-plugin
export default {"animatedBackground":"_3hwRn","placeHolderShimmer":"H_kyp","padding2":"opSph","loadingPlaceholder":"_2PRuR","card":"NgcMo","header":"_1kh33","content":"_1wjwF","footer":"Y9vFb"};